import { useNotification } from '../../contexts/NotificationContext';
import { NotificationTypeEnumerated } from '../../interfaces/notificationTypeEnumerated';
import ModalToast from '../ModalToast';
import NotificationModal from '../NotificationModal';

export const GlobalNotification = () => {
  const { notification, setNotification } = useNotification();

  if (!notification?.open) return null;

  const notificationType = notification.type ?? NotificationTypeEnumerated.INFO;

  const handleClose = () => {
    setNotification({
      ...notification,
      open: false,
      title: notification.title || '',
      text: notification.text || '',
      type: notificationType,
      duration: notification.duration || 3000,
      useModal: notification.useModal
    });
  };

  /*
   * Bug 847633: mensagem de SUCESSO nunca usa o formato modal (X + "Ok, entendi!").
   * Sucesso apenas informa e some sozinho; a confirmação do usuário fica reservada
   * a erro e aviso. Tratamos aqui, no ponto único de renderização, porque o
   * `useModal: true` está espalhado por dezenas de chamadas nas telas.
   */
  // Comparação pelo valor ('success') porque as telas usam dois enums equivalentes:
  // o NotificationTypeEnumerated local e o NotificationTypeEnum do mp-react-components.
  const sucesso = String(notificationType) === String(NotificationTypeEnumerated.SUCCESS);
  const duracao = sucesso
    ? (notification.duration && notification.duration > 0 ? notification.duration : 3000)
    : (notification.duration || 3000);

  // Se useModal for true, usa o NotificationModal com botão de fechar
  if (notification.useModal && !sucesso) {
    return (
      <NotificationModal
        open={notification.open}
        title={notification.title || ''}
        text={notification.text}
        type={notificationType as unknown as NotificationTypeEnumerated}
        onClose={handleClose}
      />
    );
  }

  // Caso contrário, usa o ModalToast original com barra de progresso
  return (
    <ModalToast
      open={notification.open}
      title={notification.title || ''}
      text={notification.text}
      duration={duracao}
      type={notificationType as unknown as NotificationTypeEnumerated}
      onClose={handleClose}
    />
  );
};
